import React from "react";
import ReactDOM from "react-dom/client";
import { H } from "highlight.run";
import { ErrorBoundary } from "@highlight-run/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { registerSW } from "./serviceWorkerRegistration";
import { isPWAInstalled } from "./utils/usePWAInstall";

H.init("5g5yyxpe", {
  serviceName: "supermarket-list",
  environment: process.env.NODE_ENV,
  tracingOrigins: true,
  networkRecording: {
    enabled: true,
    recordHeadersAndBody: true,
    urlBlocklist: [
      "https://www.googleapis.com/identitytoolkit",
      "https://securetoken.googleapis.com",
      "https://www.googletagmanager.com",
      "https://accounts.google.com/gsi/client",
      "https://www.google-analytics.com",
    ],
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
    ,
  </ErrorBoundary>,
);

const registerServiceWorker = () => {
  registerSW({
    onSuccess: () => {
      console.log("App is now ready for offline use");
    },
    onUpdate: () => {
      console.log("New app version available, please refresh");
    },
    onOfflineReady: () => {
      console.log("App is cached and ready for offline use");
    },
  });
};

if (isPWAInstalled()) {
  registerServiceWorker();
} else {
  window.addEventListener("appinstalled", () => {
    registerServiceWorker();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
